import { FieldCellMixins } from './mixins.js';

const TagsCell = {
  mixins: [FieldCellMixins],

  data: function() {
    return {
      count: this.entries.length
    };
  },

  template: `
    <div class="tag-chips table-chips">
      <div class="slp-tooltip" :data-title="toolTip" v-show="showToolTip"></div>
      <div class="chips">
        <span class="chip mr-1 text-ellipsis" v-for="tag in tags"
                                :key="tag.id"
                                ref="tagChipRef">{{ tag.value.name }}</span>
      </div>
      <span class="chip chip-placeholder" v-if="showToolTip && (entries.length > 1)" ref="chipPlaceholderRef">...</span>
    </div>
  `,

  mounted: function() {
    var chipChildren;

    chipChildren = this.$refs.tagChipRef;
    if (!chipChildren) {
      return;
    }
    this._setChipCountFunc(chipChildren, this.$el.offsetWidth);
  },

  computed: {
    toolTip: function() {
      return _.map(this.entries, (entry) => entry.value.name).join('、');
    },

    showToolTip: function() {
      return this.count < this.entries.length || this.count === 1;
    },

    tags: function() {
      return this.entries.slice(0, this.count);
    }
  },

  methods: {
    _setChipCountFunc: function(chipChildren, maxWidth) {
      var chipChild, i, len, num, width;

      num = 0;
      width = 0;
      for (i = 0, len = chipChildren.length; i < len; i++) {
        chipChild = chipChildren[i];
        // chip的margin-right是8px
        width += chipChild.offsetWidth + 8;
        if (width > maxWidth) {
          break;
        }
        num++;
      }
      this.count = num;
    }
  }
};

export { TagsCell };
